import { useCallback, useMemo, useState } from 'react';

import Toast from '../components/toast';

type ToastSeverity = 'error' | 'warning' | 'info' | 'success';

type ToastState = {
	id: number;
	body: string;
	severity: ToastSeverity;
	title?: string;
	autoHideDuration?: number;
} | null;

type ShowToastOptions = {
	title?: string;
	autoHideDuration?: number;
};

export const useToast = () => {
	const [toast, setToast] = useState<ToastState>(null);

	const showToast = useCallback((body: string, severity: ToastSeverity, options?: ShowToastOptions) => {
		setToast({
			id: Date.now(),
			body,
			severity,
			title: options?.title,
			autoHideDuration: options?.autoHideDuration,
		});
	}, []);

	const handleClose = useCallback(() => {
		setToast(null);
	}, []);

	const ToastElement = useMemo(() => {
		if (!toast) {
			return null;
		}

		return (
			<Toast
				key={toast.id}
				onClose={handleClose}
				body={toast.body}
				title={toast.title}
				severity={toast.severity}
				autoHideDuration={toast.autoHideDuration ?? 3000}
			/>
		);
	}, [handleClose, toast]);

	return {
		showToast,
		ToastElement,
	};
};
